import React from 'react'

import theme from 'theme'

const CardContainer: React.FC<
  React.HTMLAttributes<HTMLElement> & {
    showHoverEffect?: boolean
  }
> = ({ showHoverEffect = true, ...rest }) => {
  return (
    <article
      css={[
        {
          border: theme.border.base,
          borderRadius: theme.borderRadius[1],
          padding: theme.space[4],
          display: 'grid',
          gap: theme.space[3],
          position: 'relative'
        },
        showHoverEffect && {
          '&:hover, &:focus': {
            boxShadow: theme.boxShadows.medium,

            '.CardEllipsis': {
              visibility: 'visible',
              cursor: 'pointer'
            }
          }
        }
      ]}
      {...rest}
    />
  )
}

export default CardContainer
